<template>
  <div>
    <!--  補足データ選択画面 -->
    <t-card v-loading="loading">
      <div :style="{ height: basicHeight + 'px', 'padding-top': '10px' }">
        <t-form
          :model="reqInfoEditForm"
          label-position="right"
          label-width="90px"
        >
          <t-row type="flex" justify="center">
            <!-- 得意先 -->
            <t-col :span="6">
              <t-form-item
                :label="$t('resource.REQUEST_INFO.CUS_DATA')"
                class="marginBottom"
              >
                <t-input
                  v-if="this.isAdd"
                  v-model="searchConditionForm.searchCusInfo"
                  readonly
                  class="commonDialog"
                  style="margin-top: 6px"
                  @click.native="customerReferenceClick()"
                >
                  <t-button
                    slot="append"
                    class="button-default custom-button"
                    icon="el-icon-circle-close"
                    @click.native.stop="clearClick"
                  ></t-button>
                </t-input>
                <t-input
                  v-else
                  v-model="searchConditionForm.searchCusInfo"
                  disabled
                  class="commonDialog"
                  style="margin-top: 6px"
                  @click.native="customerReferenceClick()"
                >
                  <t-button
                    slot="append"
                    icon="el-icon-circle-close"
                    @click.native.stop="clearClick"
                  ></t-button>
                </t-input>
              </t-form-item>
            </t-col>

            <!-- 見積No. -->
            <t-col :span="5">
              <t-form-item
                :label="$t('resource.REQUEST_INFO.QUOTE_NO')"
                class="marginBottom"
              >
                <t-input
                  v-model="searchConditionForm.searchQuoteNo"
                  class="commonDialog"
                  maxLength="20"
                  clearable
                >
                </t-input>
              </t-form-item>
            </t-col>

            <!-- 図番. -->
            <t-col :span="5">
              <t-form-item
                :label="$t('resource.REQUEST_INFO.PRODUCT_DRAW_NO')"
                class="marginBottom"
              >
                <t-input
                  v-model="searchConditionForm.searchDrawNo"
                  class="commonDialog"
                  maxLength="30"
                  clearable
                >
                </t-input>
              </t-form-item>
            </t-col>

            <!-- 検索 -->
            <t-col :span="4" class="center">
              <t-button
                round
                type="primary"
                class="dialogButton_120_40"
                style="margin-top: 0"
                ref="searchBtn"
                @click="searchClick()"
              >
                <i class="el-icon-search"></i>
                {{ $t("resource.sys.search") }}
              </t-button>
            </t-col>
          </t-row>
        </t-form>
      </div>

      <div>
        <t-row class="marginBottom">
          <t-col
            :span="parseInt($t('widgetSize.ReceOrderSelectDialog.colOneSpan'))"
          >
            <!-- テーブル -->
            <div>
              <t-table
                ref="reqSuppProdTable"
                :data="reqSuppProdTable"
                class="table_common"
                header-cell-class-name="bg-default"
                :height="detailHeight"
                highlight-current-row
                @selection-change="handleRowClick"
                :cell-class-name="TableCellClassName"
                border
                fit
              >
                <!-- 選択ボックス -->
                <t-table-column
                  prop="selected"
                  type="selection"
                  class-name="cell_txt_center"
                />

                <!-- テーブルの列 -->
                <t-table-column
                  v-for="(column, index) in columns"
                  :key="index"
                  :type="column.type"
                  :prop="column.prop"
                  :label="column.label"
                  :min-width="column.width"
                  :align="column.align"
                  :header-align="column.headerAlign"
                  :class-name="column.class"
                  :show-overflow-tooltip="column.overflowTooltip"
                >
                </t-table-column>

                <!-- ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
                <!-- 課題_備考機能の追加 -->
                <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
                <!-- 共通備考の調整 -->
                <!-- <t-table-column
                  :label="$t('resource.REMARKS_ADD.REMARKS')"
                  class="cell_txt_center"
                  :min-width="100"
                >
                  <template slot-scope="scope">
                    <div class="button-container">
                      <t-tooltip placement="bottom" effect="light">
                        <div
                          slot="content"
                          class="tooltip-content"
                          v-html="
                            formatRemarksShowProc(scope.row.aodProdRemarksSum)
                          "
                        ></div>
                        <t-button
                          :type="getIconTypeProc(scope.row.aodProdRemarksSum)"
                          icon="el-icon-search"
                          size="small"
                          circle
                        >
                        </t-button>
                      </t-tooltip>
                    </div>
                  </template>
                </t-table-column> -->
                <t-table-column
                  :label="$t('resource.REMARKS_ADD.REMARKS')"
                  prop="aodProdRemarksSum"
                  :class-name="'cell_txt_center'"
                  :width="getRemarksColumnWidthProc()"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <div class="bikouDiv">
                      <!-- 備考表示 -->
                      <span class="bikouText">
                        {{ scope.row.aodProdRemarksSum }}
                      </span>
                    </div>
                  </template>
                </t-table-column>
                <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->
                <!-- ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->
              </t-table>
            </div>
          </t-col>
        </t-row>
      </div>
      <div :style="{ height: bottomHeight + 'px' }">
        <t-row class="marginBottom">
          <div>
            <t-col :span="20">&nbsp;</t-col>
            <t-col :span="4" class="right">
              <t-button
                round
                type="warning"
                class="dialogButton_confirm_120_40"
                ref="confirmBtn"
                @click="confirmClick"
              >
                <i class="el-icon-check"></i>
                {{ $t("resource.sys.sure") }}</t-button
              >
            </t-col>
          </div>
        </t-row>
      </div>
    </t-card>
  </div>
</template>
<script>
import { ShowCustomerReferenceDialog } from "@/components/Dialog";
import { t } from "@/locales";
import {
  getReqSuppDetailInfo,
  searchSuppSelectInfo,
} from "@/services/requestInfo";

import { getCusCalculateDate } from "@/services/send";
import {
  formatCurrencyToNumber,
  formatDateToString,
  formatRemarksShow,
  formatStringToCurrency,
  getDialogContentHeight,
  getEditColWidthArr,
  getIconType,
  getRemarksColumnWidth,
} from "@/utils/comFunction";
import {
  DIALOG_LINE_HEIGHT,
  STR_BACKSLASH,
  STR_TWELVE,
  STR_ZERO,
  STR_ZERO_ONE,
} from "@/utils/const";
import { flexColumnWidth, setColumnWidth } from "@/utils/table";
import { Message, Modal } from "@tellus/component";
export default {
  data() {
    return {
      //検索条件
      searchConditionForm: {
        searchCusCode: "", // 得意先
        searchCusInfo: "", // 得意先
        searchQuoteNo: "", // 見積No.
        searchDrawNo: "", // 図番
        rbrequestNo: this.requestNo,
      },

      rbRequestNo: this.requestNo, // 請求No.

      reqInfoEditForm: {
        // 請求予定日
        quoteDateRange: "",
        // 得意先
        rbCusInfo: "",
        // 請求予定日
        rbRequestExpectedDate: "",
        // 請求予定日(開始日)
        startDate: "",
        // 請求予定日(終了日)
        endDate: "",
      },

      loading: false,
      //受注一覧選択情報
      reqSuppProdTable: [],

      cusCalculateDate: 0,

      //列の幅
      colArr: getEditColWidthArr(window.innerWidth, 4),

      //仕入先見積依頼のテーブルの列
      columns: [
        // 見積No.
        {
          prop: "rdQuoteNo",
          label: t("resource.REQUEST_INFO.QUOTE_NO"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },

        // 得意先
        {
          prop: "rdCusCodeShow",
          label: t("resource.REQUEST_INFO.CUS_DATA"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },

        //品名
        {
          prop: "aodProdName",
          label: t("resource.CUSTOMER_PAY.PRODUCT_NAME"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        //図番
        {
          prop: "aodProdDrawNo",
          label: t("resource.CUSTOMER_PAY.PRODUCT_DRAW_NO"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },

        //補足数
        {
          prop: "sendQty",
          label: t("resource.CUSTOMER_PAY.SUPPLEMENT_COUNT"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_right",
        },
        // 単位
        {
          prop: "aodProdUnit",
          label: t("resource.REQUEST_INFO.AOD_PROD_UNIT"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center ",
          overflowTooltip: false,
        },

        //補足単価
        {
          prop: "salesPrice",
          label: t("resource.CUSTOMER_PAY.SUPPLEMENT_U_PRICE"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_right",
        },

        //補足金額小計
        {
          prop: "totalAounnt",
          label: t("resource.CUSTOMER_PAY.SUPPLEMENT_AMOUNT"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_right",
        },

        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 課題_備考機能の追加
        // // 備考
        // {
        //   prop: "rdRemarks",
        //   label: t("resource.CUSTOMER_PAY.REMARKS"),
        //   width: 180,
        //   class: "cell_txt_left",
        //   overflowTooltip: true,
        // },
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
      ],

      //現在選択されているセル
      currentCell: [],

      //基本情報のheight
      basicHeight: DIALOG_LINE_HEIGHT,
      //明細情報のheight
      detailHeight: getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT,
        DIALOG_LINE_HEIGHT,
        30
      ),
      //確定ボタンのheight
      bottomHeight: DIALOG_LINE_HEIGHT,

      yourDesiredColor: "#FF0000",
    };
  },

  props: {
    isAdd: {
      Type: Boolean,
      default: false,
    },
    tableData: {
      Type: Object,
      default: null,
    },
    rbCusInfo: {
      Type: Object,
      default: null,
    },
    rbRequestDate: {
      Type: Object,
      default: null,
    },
    selectSuppSearchForm: {
      Type: Object,
      default: null,
    },
    requestNo: {
      Type: Object,
      default: null,
    },
  },
  mounted() {
    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);

    // 初期化
    this.init();
  },

  watch: {
    // // 請求日
    // "reqInfoEditForm.quoteDateRange"(value) {
    //   // 請求日処理
    //   this.editDate(value);
    // },
  },

  methods: {
    // 初期化
    init() {
      // 得意先
      this.searchConditionForm.searchCusInfo = this.rbCusInfo;

      if (!!this.selectSuppSearchForm) {
        if (!!this.selectSuppSearchForm.searchQuoteNo) {
          this.searchConditionForm.searchQuoteNo =
            this.selectSuppSearchForm.searchQuoteNo; // 見積No.
        }
        if (!!this.selectSuppSearchForm.searchDrawNo) {
          this.searchConditionForm.searchDrawNo =
            this.selectSuppSearchForm.searchDrawNo; // 図番
        }
      }

      this.searchClick();
    },

    // 検索
    searchClick() {
      if (!this.loading) {
        this.loading = true;
      }
      //検索条件の処理
      this.updateSearchForm();
      this.searchConditionForm.rbrequestNo = this.rbRequestNo;
      // 請求製品情報の取得
      searchSuppSelectInfo(this.searchConditionForm)
        .then((res) => {
          this.reqSuppProdTable = res;
          this.dataProcess();
          // 詳細画面選択のデータ選択チェックボックス
          this.checkedProcess();

          Message.showSuccess(t("message.COMMON_MESSAGE.SEARCH_SUCCESS"));
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
        })
        .finally(() => {
          setColumnWidth(this.columns, this.reqSuppProdTable);
          this.loading = false;

          // フォーカス削除
          this.$refs.searchBtn.$el.blur();
        });
    },

    //検索条件の処理
    updateSearchForm() {
      // 得意先
      if (!!this.searchConditionForm.searchCusInfo) {
        this.searchConditionForm.searchCusCode =
          this.searchConditionForm.searchCusInfo.split(":")[0];
      }
      // 見積No.
      this.searchConditionForm.searchQuoteNo =
        this.searchConditionForm.searchQuoteNo.trim();
      // 図番
      this.searchConditionForm.searchDrawNo =
        this.searchConditionForm.searchDrawNo.trim();
    },

    //一覧データの処理
    dataProcess() {
      this.reqSuppProdTable.forEach((item) => {
        // 補足単価
        item.salesPrice = formatStringToCurrency(item.salesPrice);
        // 補足金額小計
        item.totalAounnt = formatStringToCurrency(item.totalAounnt);
      });
    },

    // 詳細画面選択のデータ選択チェックボックス
    checkedProcess() {
      if (!!this.tableData) {
        this.tableData.forEach((row) => {
          for (let index = 0; index < this.reqSuppProdTable.length; index++) {
            const element = this.reqSuppProdTable[index];

            //詳細画面選択のデータ選択チェックボックス
            if (
              row.rdQuoteNo == element.rdQuoteNo &&
              row.rdProdNo == element.rdProdNo
            ) {
              this.$nextTick(() => {
                this.$refs.reqSuppProdTable.toggleRowSelection(
                  this.reqSuppProdTable[index],
                  true
                );
              });
            }
          }
        });
      }
    },

    // 选中的行数据
    handleRowClick(row) {
      this.currentCell = row;
    },

    //テーブルの高さを設定する
    handleResize() {
      this.detailHeight = getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT,
        DIALOG_LINE_HEIGHT,
        30
      );

      this.colArr = getEditColWidthArr(window.innerWidth, 4);
    },

    // クリアボタン
    clearClick() {
      if (this.isAdd) {
        this.searchConditionForm.searchCusInfo = "";
        this.searchConditionForm.searchCusCode = "";
      }
    },

    //参照ボタン
    customerReferenceClick() {
      if (!this.isAdd) {
        return;
      }

      var arr = this.searchConditionForm.searchCusInfo?.split(":");
      var sbCusCode = arr?.length > 0 ? arr[0] : "";

      // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
      var filterCustomerList = this.filterCustomerListProc(this.reqSuppProdTable);
      // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑

      ShowCustomerReferenceDialog(
        // UPD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
        // 請求製品選択の得意先選択画面の初期データの変更
        // { cusCode: sbCusCode },
        {
          cusCode: sbCusCode,
          requestFlg: true,
          filterCustomerList: filterCustomerList,
        },
        // UPD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑
        t("resource.numberEditInfo.customerReferenceView"),
        (target) => {
          if (!!target) {
            this.searchConditionForm.searchCusInfo = target;
            // this.getCusCalculateDateProc();
          }
        }
      );
    },

    //确定ボタン
    confirmClick() {
      if (this.currentCell.length >= 1) {
        // 得意先情報の選択チェック
        if (!this.selectCheck()) {
          Modal.showWarning("", t("message.REQUEST_INFO.CUS_SELECT_FAILED"), {
            confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          });
          return;
        }

        // 請求製品情報の取得
        this.getReqSuppDetailInfo();
      } else {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      }

      // フォーカス削除
      this.$refs.confirmBtn.$el.blur();
    },

    // ダイアログを閉じる
    close() {
      this.$emit("cancel");
    },

    // 請求製品情報の取得
    getReqSuppDetailInfo() {
      getCusCalculateDate({ sbCusCode: this.currentCell[0].rdCusCode }).then(
        (res) => {
          this.cusCalculateDate = parseInt(res.cusCalculateDate);

          var rbRequestExpectedDate = this.setReqExceptDate(
            this.cusCalculateDate
          );

          for (let index = 0; index < this.currentCell.length; index++) {
            this.currentCell[index].requestNo = this.rbRequestNo;
          }

          // 請求製品情報の取得
          getReqSuppDetailInfo(this.currentCell, this.rbRequestNo)
            .then((res) => {
              const result = {
                rbCusInfo: this.currentCell[0].rdCusCodeShow,
                rowData: res,
                rbRequestExpectedDate: rbRequestExpectedDate,
                selectSuppSearchForm: this.searchConditionForm,
              };

              this.$emit("ok", result);
            })
            .catch((err) => {
              if (err.data != null) {
                Message.showError(
                  t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
                );
              } else {
                Message.showError(
                  t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
                );
              }

              const result = {
                rbCusInfo: this.searchConditionForm.searchCusInfo,
              };

              this.$emit("err", result);
            });
        }
      );
    },

    /**
     * el-table-column 自适应列宽
     * @param prop_label: 表名
     * @param table_data: 表格数据
     */
    flexColumnWidthFunc(label, prop) {
      return flexColumnWidth(label, prop, this.orderProductForm);
    },

    // 得意先情報の選択チェック
    selectCheck() {
      let result = true;

      let oldCusInfo = this.currentCell[0].rdCusCode;
      this.currentCell.forEach((element) => {
        if (element.rdCusCode != oldCusInfo) {
          result = false;
          return;
        }
      });

      return result;
    },

    //請求予定日の取得
    setReqExceptDate(cusCalculateDate) {
      let rbRequestDate = new Date(this.rbRequestDate);
      const [rbRequestYear, rbRequestMonth, rbRequestDay] =
        formatDateToString(rbRequestDate).split(STR_BACKSLASH);
      //年
      var year = rbRequestDate.getFullYear();

      // ADD 2025/02/26 ZLL 課題_納品請求予定日の検討 start↓
      var month = rbRequestDate.getMonth() + 1;
      // 現在の月の最大日数を取得
      const lastDayOfMonth = new Date(year, month, 0).getDate();
      // ADD 2025/02/26 ZLL 課題_納品請求予定日の検討 end↑

      if (rbRequestDay > cusCalculateDate) {
        month = (rbRequestDate.getMonth() + 1).toString();
        if (month === STR_TWELVE) {
          year++;
          month = STR_ZERO_ONE;
        } else {
          month = (rbRequestDate.getMonth() + 2)
            .toString()
            .padStart(2, STR_ZERO);
        }
      } else {
        //月(date.getMonth(): 0~11)
        month = (rbRequestDate.getMonth() + 1).toString().padStart(2, STR_ZERO);
      }

      // ADD 2025/02/26 ZLL 課題_納品請求予定日の検討 start↓
      if (lastDayOfMonth < cusCalculateDate) {
        // 現在の月の最終日に設定
        cusCalculateDate = lastDayOfMonth;
      }
      // ADD 2025/02/26 ZLL 課題_納品請求予定日の検討 end↑

      return year + STR_BACKSLASH + month + STR_BACKSLASH + cusCalculateDate;
    },

    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
    //セルの配置
    TableCellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column.index = columnIndex;
      if (
        (column.property === "sendQty" && row.sendQty < 0) ||
        (column.property === "totalAounnt" &&
          formatCurrencyToNumber(row.totalAounnt) < 0)
      ) {
        return "txt-cell-editable_red";
      }
    },
    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
    // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
    // 課題_備考機能の追加
    //備考表示用
    formatRemarksShowProc(value) {
      return formatRemarksShow(value);
    },

    getIconTypeProc(value) {
      return getIconType(value);
    },

    // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
    // 共通備考の調整（備考列幅の設定）
    getRemarksColumnWidthProc() {
      return getRemarksColumnWidth(this.reqSuppProdTable);
    },
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑

     // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
    // 請求製品選択の得意先選択画面の初期データの変更
    // 請求可能な得意先リストのフィルタ
    filterCustomerListProc(requestProductForm) {
      const customerCodes = requestProductForm
        .map(item => item.rdCusCode)  // 得意先コードの取得
        .filter((value, index, self) => self.indexOf(value) === index);  // 重複排除
      return customerCodes;
    }
    // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑

  },
};
</script>
<style scoped>
.el-form-item__label.custom-label {
  width: 20%;
}

.left-align {
  justify-content: left !important;
}

/* 设置按钮的文本颜色 */

/* 设置按钮的背景颜色 */
.el-button.button-default.custom-button.el-button--default {
  background-color: #ffffff; /* 你想要的背景颜色 */
  height: 27.5px;

  padding-top: 6.5px;
  border-radius: 1;
}
</style>
